import { Loader } from '@/components/ui'
import { cn } from '@/utils'
import { SHEET_ASPECT_RATIO } from './strip'

interface PlaceholderSheetProps {
  width: number
  loading?: boolean
  className?: string
}

// A page we are not drawing yet: the strip is moving, or the image is still being rendered. It is
// the same size as the art, so nothing shifts when the real page arrives. Only the sheet pulses,
// never the labels beside it, or a strip of them would read as a broken screen.
export const PlaceholderSheet = ({
  width,
  loading,
  className,
}: PlaceholderSheetProps) => (
  <div
    data-page-placeholder
    className={cn(
      'flex shrink-0 items-center justify-center rounded-sm border border-neutral-200 bg-white',
      loading && 'animate-pulse',
      className,
    )}
    style={{ width, aspectRatio: SHEET_ASPECT_RATIO }}
  >
    {loading ? (
      <span data-page-spinner className="flex">
        <Loader className="text-neutral-400" />
      </span>
    ) : null}
  </div>
)
